// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"462df57c","521":"f53f1f8f","726":"be7abf4f"}[chunkId] + ".css";
};